module.exports = __webpack_public_path__ + "static/media/05.52ca27a9.png";